import { delay } from "msw";

export const MOCK_LATENCY_MS = import.meta.env.MODE === "test" ? 0 : 2000;

const CHAINED_REQUEST_GAP_MS = 500;

export const createLatencyWindow = (
  windowMs: number,
  chainedRequestGapMs = CHAINED_REQUEST_GAP_MS,
) => {
  let windowEndsAt = Number.NEGATIVE_INFINITY;
  let lastResolvesAt = Number.NEGATIVE_INFINITY;
  let windowScreen: string | null = null;

  const getDelay = (now: number, screen: string) => {
    const isNewScreen = screen !== windowScreen;
    const isIdle = now > lastResolvesAt + chainedRequestGapMs;

    if (isNewScreen || isIdle) {
      windowEndsAt = now + windowMs;
      windowScreen = screen;
    }

    lastResolvesAt = Math.max(lastResolvesAt, windowEndsAt, now);

    return Math.max(0, windowEndsAt - now);
  };

  return { getDelay };
};

const latencyWindow = createLatencyWindow(MOCK_LATENCY_MS);

export const waitForMockLatency = () => {
  return delay(latencyWindow.getDelay(Date.now(), globalThis.location?.pathname ?? ""));
};
